<label *ngIf="label" class="form-label !mb-1.5 !block !text-sm !font-semibold !text-slate-600" [attr.for]="inputId || null">
    {{ label }}
</label>
<div class="!flex !h-11 !min-h-11 !overflow-hidden !rounded-xl !border !border-solid !border-slate-200 !bg-white focus-within:!border-primary focus-within:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
     [class.!opacity-60]="disabled">
    <button type="button"
            class="!m-0 !inline-flex !h-full !shrink-0 !appearance-none !items-center !gap-1.5 !border-0 !border-r !border-solid !border-slate-200 !bg-slate-50 !px-3 !text-slate-500 !shadow-none hover:!bg-slate-100 hover:!text-primary focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-inset focus-visible:!ring-primary"
            [attr.aria-label]="label || placeholder"
            [disabled]="disabled"
            (click)="openPicker()">
        <i class="bi" [ngClass]="icon" aria-hidden="true"></i>
    </button>
    <button type="button"
            class="!m-0 !flex !h-full !min-w-0 !flex-1 !appearance-none !items-center !border-0 !bg-white !px-3.5 !text-left !shadow-none focus-visible:!outline-none"
            [disabled]="disabled"
            (click)="openPicker()">
        <span class="!truncate !text-sm"
              [ngClass]="displayName ? '!font-medium !text-slate-800' : '!text-slate-400'">
            {{ displayName || placeholder }}
        </span>
    </button>
    <a *ngIf="fileUrl"
       [href]="fileUrl"
       target="_blank"
       rel="noopener"
       class="!m-0 !inline-flex !h-full !shrink-0 !items-center !border-0 !border-l !border-solid !border-slate-200 !bg-white !px-3 !text-xs !font-semibold !text-primary hover:!bg-slate-50">
        Apri
    </a>
</div>
<input #fileInput
       type="file"
       class="d-none"
       [id]="inputId"
       [accept]="accept"
       [disabled]="disabled"
       (change)="onFileChange($event)"/>
<p *ngIf="hint" class="!mb-0 !mt-1.5 !text-xs !leading-snug !text-slate-400">{{ hint }}</p>
